<template>
  <div class="md-layout" :class="{ _attachmentsForm__isDeleted: model.isDeleted }">

    <div class="md-layout-item md-size-15 md-small-size-100">
      <md-checkbox v-model="model.internal" :disabled="!isInternalGroupMember">Internal</md-checkbox>
    </div>
    
    <div class="md-layout-item md-size-20 md-small-size-100">
      <md-field class="_uiKitInput">
        <label>Name</label>
        <md-input :value="model ? model.name: ''" :disabled="true" />
      </md-field>
    </div>
    
    <div class="md-layout-item md-size-25 md-small-size-100">
      <md-field class="_uiKitInput">
        <label>Document Type</label>
        <md-select v-model="model.type" required>
          <md-option
            v-for="(_option, _index) in docTypes"
            :key="_index"
            :value="_option.id"
            >{{ _option.label }}</md-option
          >
        </md-select>
      </md-field>
    </div>
    
    <div class="md-layout-item md-size-30 md-small-size-100">
      <md-field class="_uiKitInput">
        <label>Description</label>
        <md-input v-model="model.description" />
      </md-field>
    </div>

    <div class="md-layout-item md-size-5 md-small-size-100">
      <md-button
        v-if="$Session.isAdminGroupMember"
        class="md-just-icon md-danger md-simple"
        :disabled="isDeleteDisabled && model.id"
        @click.stop.native="handleDelete"
      >
        <md-icon>close</md-icon>
      </md-button>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'AttachmentsFormItem',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    docTypes: {
      type: Array,
      required: true,
    },
    isDeleteDisabled: {
      type: Boolean,
      default: false,
    },
    isAttachmentsList: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    model: {
      file: null,
      type: null,
      internal: false,
      description: null,
    }
  }),
  computed: {
    isInternalGroupMember() {
      return this.$reduce(this, '$Session.isInternalGroupMember');
    },
  },
  methods: {
    handleDelete() {
      this.$set(this.model, 'isDeleted', true)
      console.log(this.model)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function() {
        this.$set(this, 'model', this.value)
      }      
    },
    /**
     * Whenever any value changes in model - emit the new model value
     */
    'model': {
      deep: true,
      immediate: true,
      handler: function() {
        this.$emit('input', this.model);
      }
    }
  },
};
</script>

<style lang="scss">
</style>
